/* Generated File DO NOT EDIT. */
/* tslint:disable */
import * as Types from '../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HomeQueryVariables = Types.Exact<{
  offset: Types.Scalars['Int'];
}>;

export type HomeQuery = {
  __typename?: 'Query';
  needToScheduleActivity: boolean;
  needToAnswerDailyLog: boolean;
  needToAnswerWeeklyLog: boolean;
  needToCompleteRegistration: boolean;
  isFirstWeek: boolean;
  activities: Array<{
    __typename?: 'Activity';
    _id: string;
    weekOf: string;
    description: string;
    type: Types.ActivityType;
    subgoal?: string | null;
    domain: { __typename?: 'Domain'; _id: string; title: string; iconUrl?: string | null; color?: string | null };
    schedule: Array<{ __typename?: 'DayAndPeriod'; day: string; period: Array<string> }>;
  }>;
  previousActivities: Array<{
    __typename?: 'Activity';
    _id: string;
  }>;
};

export const HomeDocument = gql`
  query home($offset: Int!) {
    needToScheduleActivity(offset: $offset)
    needToAnswerDailyLog(offset: $offset)
    needToAnswerWeeklyLog(offset: $offset)
    needToCompleteRegistration
    isFirstWeek
    activities(offset: $offset, includeFuture: true) {
      _id
      weekOf
      description
      domain {
        _id
        title
        iconUrl
        color
      }
      type
      schedule {
        day
        period
      }
      subgoal
    }
    previousActivities(offset: $offset) {
      _id
    }
  }
`;

/**
 * __useHomeQuery__
 *
 * To run a query within a React component, call `useHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useHomeQuery(baseOptions: Apollo.QueryHookOptions<HomeQuery, HomeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HomeQuery, HomeQueryVariables>(HomeDocument, options);
}
export function useHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeQuery, HomeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<HomeQuery, HomeQueryVariables>(HomeDocument, options);
}
export type HomeQueryHookResult = ReturnType<typeof useHomeQuery>;
export type HomeLazyQueryHookResult = ReturnType<typeof useHomeLazyQuery>;
export type HomeQueryResult = Apollo.QueryResult<HomeQuery, HomeQueryVariables>;
